import { each } from 'lodash';
import { change } from 'redux-form';
import { createAction } from '@mews/framework';
import { CommanderThunkAction, Place } from '@mews-commander/types';
import { enterpriseAddressAutocomplete } from '@mews-commander/utils';
import { AUTOCOMPLETE_NAME } from '../../../components/form';
import { EnterpriseFormValues } from '../types';
import { SETTINGS_ADDED } from './types';

export const addSettings =
    (data: EnterpriseFormValues): CommanderThunkAction =>
    (dispatch) =>
        dispatch(createAction(SETTINGS_ADDED, data));

export const autocompleteAddress =
    (form: string, place: Place): CommanderThunkAction =>
    (dispatch) => {
        const values = enterpriseAddressAutocomplete(place);
        dispatch(change(form, AUTOCOMPLETE_NAME, ''));
        each(values, (value, field) => {
            dispatch(change(form, field, value));
        });
    };
